// extracted by mini-css-extract-plugin
export default {"link":"CustomLink_link__faHZS","isActive":"CustomLink_isActive__isGyC"};